let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("a4yJG")).then(() => parcelRequire('eG1e2'));